'use client';
import { __rest } from '../../node_modules/tslib/tslib.es6.js';
import { jsx, Fragment } from 'react/jsx-runtime';
import { withTitan } from '../../hocs/withTitan/withTitan.js';
import { Checkbox } from '../Checkbox/Checkbox.js';

const TableCheckbox = /*#__PURE__*/withTitan(_a => {
  var {
      shouldRender
    } = _a,
    props = __rest(_a, ["shouldRender"]);
  if (!shouldRender) {
    return jsx(Fragment, {});
  }
  return jsx(Checkbox, Object.assign({
    isLabelHidden: true,
    name: "select"
  }, props));
}, {
  name: 'TableCheckbox'
});

export { TableCheckbox };
//# sourceMappingURL=TableCheckbox.js.map
